<script lang="ts">
  import { getAppConfig } from '../../../common/config/app-config';

  export let condition: string | null | undefined;

  const { lang, pageId } = getAppConfig();

  const CONDITION_IMAGE_MAP = {
    RENEWED: {
      en: '/_ui/responsive/theme-extra/images/renewed.svg',
      ar: '/_ui/responsive/theme-extra/images/renewed_ar.svg',
    },
    OPEN_BOX: {
      en: '/_ui/responsive/theme-extra/images/openbox.svg',
      ar: '/_ui/responsive/theme-extra/images/openbox_ar.svg',
    },
  };

  const CONDITION_ALT_MAP = {
    RENEWED: 'Renewed',
    OPEN_BOX: 'Open Box',
  };

  $: imageSrc = condition ? CONDITION_IMAGE_MAP[condition]?.[lang === 'ar' ? 'ar' : 'en'] : undefined;

  $: altText = condition ? CONDITION_ALT_MAP[condition] : '';
</script>

{#if imageSrc}
  <img class="product-condition-tag {pageId}" src={imageSrc} alt={altText} loading="lazy" decoding="async" />
{/if}

<style>
  .product-condition-tag {
    display: block;
    width: 56px;
    height: 18px;
    flex-shrink: 0;
    object-fit: contain;
    transform: translateY(-1px);
    &.productDetails {
      width: 82px;
      height: 25px;
    }
  }
</style>
